import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * The Grab Bonus badge, shared by the route card, route details and the itinerary header.
 * Size is driven by `width` alone - the count scales with it - so the three callers stay consistent.
 */
@Component({
  selector: 'grab-bonus-badge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './grab-bonus-badge.component.html',
  styleUrls: ['./grab-bonus-badge.component.scss'],
})
export class GrabBonusBadgeComponent {
  @Input() count: number = 0;

  /** Rendered width in px. The artwork keeps its aspect ratio and the count scales to match. */
  @Input() width: number = 130;

  // Keeps the count in proportion to the artwork's clear area at any width.
  get countFontSize(): number {
    return Math.round(this.width * 0.15);
  }
}
